import { NodeViewWrapper } from '@tiptap/react';
import QRCode from 'react-qr-code';

const QRCodeComponent = ({ node }) => {
    const url = node.attrs.url || 'https://default-url.com';

    return (
        <NodeViewWrapper
            as="span"
            className="qr-code"
            contentEditable={false}
            style={{ display: 'inline-block', cursor: 'pointer' }}
        >
            <QRCode value={url} size={128} />
        </NodeViewWrapper>
    );
};

export default QRCodeComponent;
